import React, {Component} from 'react';
import {connect} from 'react-redux';

import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import * as actions from '../../store/actions/index';
import Select from "react-select";
import api from "../../services/api";
import configToken from "../../utils/configToken";

class Contato extends Component {
    state = {
        reason: '',
        page: '',
        content: '',
        load: false
    }

    componentDidMount() {
    }

    submitHandler = (event) => {
        event.preventDefault();
        this.setState({loading: true})
        const userdata = {
            reason: this.state.reason,
            page: this.state.page,
            content: this.state.content
        }
        console.log('userdata',userdata)
        api.post('/contact', userdata, configToken())
            .then(res => {
                alert('Mensagem enviado com sucesso')
                this.setState({loading: false, reason: '', page: '', content: ''})
            })
            .catch(err => {
            })

    }

    render() {

        let {
            loading,
            content
        } = this.state

        let load = <span/>

        if(loading){
            load = <Spinner/>
        }

        return <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    <br/>
                    <br/>
                    <p className="titulo">Envia um mensagem de contato</p>
                    <form onSubmit={this.submitHandler}>
                        {load}
                        {!loading && <div> <Select
                            required
                            name={'reason'}
                            isSearchable
                            placeholder={'Escolha um motivo'}
                            options={[
                                {value: 'Ajuste', label: 'Ajuste'},
                                {value: 'Sugestão', label: 'Sugestão'}
                            ]}
                            onChange={e => this.setState({reason: e.value})}
                        />
                        <br/>
                        <Select
                            required
                            name={'page'}
                            isSearchable
                            placeholder={'Escolha um item'}
                            options={[
                        {value: 'Home', label: 'Home'},
                        {value: 'Meus Imóveis (mapa)', label: 'Meus Imóveis (mapa)'},
                        {value: 'Meus Imóveis (lista)', label: 'Meus Imóveis (lista)'},
                        {value: 'Buscar Imóveis (mapa)', label: 'Buscar Imóveis (mapa)'},
                        {value: 'Buscar Imóveis (lista)', label: 'Buscar Imóveis (lista)'},
                        {value: 'Meus Clientes', label: 'Meus Clientes'},
                        {value: 'Editar Imóveis', label: 'Editar Imóveis'},
                        {value: 'PDF Imóveis', label: 'PDF Imóveis'},
                        {value: 'Localização', label: 'Localização'},
                        {value: 'Outros', label: 'Outros'}
                            ]}
                            onChange={e => this.setState({page: e.value})}
                            />
                            <br/>
                            <textarea name={'content'} value={content} className={'form-control'} placeholder={'Mensagem'} onChange={e => this.setState({content: e.target.value})}/>
                            <br/>
                            <Button>Enviar</Button></div>}

                    </form>

                </div>
            </div>
        </div>;
    }
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        messagedone: state.auth.messagedone,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSignup: (formdata) => dispatch(actions.signup(formdata))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Contato);
